<!-- PROJECT -->
<template>
    <div>
        <!-- // * CONTENT TITLE (GENERIC) -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">

                    <v-icon v-if="form.projectStatus === 'LIVE'"  class="display-1 success--text icons8-checkmark-yes"></v-icon>
                    <v-icon v-if="form.projectStatus === 'ONHOLD'" class="display-1 warning--text icons8-private"></v-icon>
                    <v-icon v-if="form.projectStatus === 'PENDING'" class="display-1 grey--text icons8-circle"></v-icon>
                    <v-icon v-if="form.projectStatus === 'DRAFT'" class="display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>


                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <appbutton :label="$t('buttons.viewDocuments')" v-if="formMode === 'View'" icon="icons8-open-view" type="secondary"  class="" @click.native="openProject()"  />
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>

                        </v-tabs>
                        <!-- // * TABS ITEMS -->
                        <v-tabs-items v-model="tabs" class="appbackground">

                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text class="help-text" v-if="GET_help && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.contractor`)"></app-text>
                                                <app-text class="help-text" v-if="GET_help && GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.default`)"></app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex pl-1 pr-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />
                                            </v-col>
                                        </v-row>
                                        <v-form ref="form"  >
                                            <v-row class="mt-2" no-gutters>
                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">PROJECT</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <!-- PROJECT NAME (CUSTOM) -->
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <v-text-field color="black" :label="$t('fields.name')" v-model="form.projectName" :rules="rules.projectName" filled required hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                                </v-col>
                                                <!-- PROJECT REFERENCE (CUSTOM) -->
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-text-field color="black" :label="$t('fields.projectRef')" v-model="form.projectRef" :rules="rules.ref" filled required hide-details="auto" :background-color="formBackground" dense :readonly="true" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t('fields.projectManager')" v-model="form.projectManager" filled hide-details :background-color="formBackground" dense auto-select-first :items="usersHosts" item-text="userName" return-object :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                        <template v-slot:item="data">
                                                            {{ data.item.userName }}<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.userName }}<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <v-textarea color="black"  :label="$t('fields.description')" v-model="form.projectDescription" :rules="rules.description" filled required hide-details="auto" :background-color="formBackground" dense auto-grow rows="1" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-textarea>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-text-field color="black" @click="MIX_datePicker(true, 'projectStartDate')" :rules="rules.projectStartDate" append-icon="mdi-calendar" :label="$t('fields.projectStartDate')" v-model="formattedProjectStartDate" filled required hide-details="auto" :background-color="formBackground" dense :readonly="true" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-text-field color="black" @click="MIX_datePicker(true, 'projectEndDate')" :rules="rules.projectEndDate" append-icon="mdi-calendar" :label="$t('fields.projectEndDate')" v-model="formattedProjectEndDate" filled required hide-details="auto" :background-color="formBackground" dense :readonly="true" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" v-if="formMode === 'New'">
                                                    <v-row class="mx-2 my-0">
                                                        <v-checkbox color="primary" v-model="permitToWork"> 
                                                            <span slot="label" class="darkgrey--text text-body-2 text--capitalize">PERMIT TO WORK REQUIRED<br /><span class="font-weight-light grey--text darken-2">If works such as Working from Height, Hot Works, Confined Spaces, Electrical, Asbestos, COSHH etc</span></span>
                                                        </v-checkbox>
                                                        <v-spacer />
                                                    </v-row>
                                                    <v-row class="mx-2 my-0 justify-end">
                                                        <div v-if="permitToWork === true" class="d-flex justify-end">
                                                            <v-btn class="ml-1 white--text grey darken-2" elevation="0" href="https://firebasestorage.googleapis.com/v0/b/tfw-swapp.appspot.com/o/downloads%2FAppendix%20C%20TFW%20RL%20Fleet%20Permit%20To%20Work.docx?alt=media&token=6e4fe678-385d-484a-b3cd-e0a74e6aedb6">
                                                                Click here to Download Permit <v-icon class="pl-2 white--text">icons8-download</v-icon>
                                                            </v-btn>
                                                        </div> 
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row class="mx-2 my-0 align-center">
                                                        <v-checkbox color="primary" v-model="form.inviteStaff" class=""> 
                                                            <span slot="label" class="darkgrey--text text-body-2 text--capitalize">NOTIFY STAFF OF PROJECT<br /><span class="font-weight-light grey--text darken-2">As a minimum you must notify relevant depot Site Manager, Facilities Manager & Duty Depot Managers</span></span>
                                                        </v-checkbox>
                                                        <v-spacer />
                                                        <v-col v-if="form.inviteStaff === true && formMode === 'New'" class="pr-1 pb-1 pl-0 py-0" cols="12">
                                                            <v-select :menu-props="{ top: true, offsetY: true }" :attach="true" label="Staff Members" v-model="invitedStaffMembers" :items="computedTFWStaff" multiple item-text="userName" item-value="userId" filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                                <template v-slot:selection="{ item, index }">
                                                                    <span v-if="index === 0">{{ item.userName }}</span>
                                                                    <span v-if="index === 1" class="grey--text caption ml-2"> and {{ invitedStaffMembers.length - 1 }} other </span>
                                                                </template>                                          
                                                            </v-select>
                                                        </v-col>
                                                        <v-col v-else-if="form.inviteStaff === true && formMode === 'Edit' || form.inviteStaff === true && formMode === 'View'" class="pr-1 pl-0 py-0" cols="12">
                                                            <v-select :menu-props="{ top: true, offsetY: true }" :attach="true" label="Staff Members" v-model="form.invitedStaffMembers" :items="computedTFWStaff" multiple item-text="userName" item-value="userId" filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                                <template v-slot:selection="{ item, index }">
                                                                    <span v-if="index === 0">{{ item.userName }}</span>
                                                                    <span v-if="index === 1" class="grey--text caption ml-2"> and {{ form.invitedStaffMembers.length - 1 }} other </span>
                                                                </template>                                          
                                                            </v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
												<!--SITE-->
                                                <v-col class="mb-2 mt-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">SITE</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-autocomplete multiple :menu-props="{ top: true, offsetY: true }" :attach="true" color="black"  :label="$t('fields.site')" v-model="form.site" :rules="rules.siteID" filled required hide-details="auto" :background-color="formBackground" dense auto-select-first :items="sites" item-text="siteName" return-object :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-autocomplete>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-autocomplete :menu-props="{ top: true, offsetY: true }" :attach="true" color="black"  :label="$t('fields.siteManager')" v-model="form.siteManager" :rules="rules.siteManager" filled required hide-details="auto" :background-color="formBackground" dense auto-select-first :items="usersHosts" item-text="userName" return-object :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                        <template v-slot:item="data">
                                                            {{ data.item.userName }}<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.userName }}<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                                                    <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t('fields.status')" v-model="form.projectStatus" :rules="rules.projectStatus" :items="projectStatus" item-value="value" dense filled required hide-details="auto" :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                        <template v-slot:item="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <!-- CONTRACTOR -->
                                            <v-row class="ma-0 pa-0 " no-gutters>
                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">CONTRACTOR</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <!-- <pre>{{ organisations }}</pre> -->
                                                <v-col class="my-2 px-2" cols="12">
                                                    <v-autocomplete 
                                                        :menu-props="{ top: true, offsetY: true }" 
                                                        :attach="true" 
                                                        color="black"  
                                                        autocomplete="donotautocomplete" 
                                                        item-text="organisationName" 
                                                        :rules="rules.organisation" 
                                                        :label="$t(`fields.organisation`)" 
                                                        v-model="form.organisation" 
                                                        :items="organisations" 
                                                        hide-details="auto" 
                                                        required 
                                                        return-object 
                                                        filled 
                                                        multiple
                                                        :background-color="formBackground" 
                                                        dense 
                                                        :clearable="!formReadOnly" 
                                                        :readonly="formReadOnly" 
                                                        :class="{ 'disabled': formReadOnly}">
                                                        <template v-slot:item="data">{{ data.item.organisationName }}</template>
                                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                                            <!-- {{ data.item.organisationName }},  -->
                                                            <v-chip v-bind="attrs" class="grey lighten-3" :input-value="selected" label small>
                                                                <span class="pr-2">
                                                                    {{ item.organisationName }}
                                                                </span>
                                                                <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </v-autocomplete>
                                                        <!-- @change="getUsersFromOrganisation"  -->
                                                </v-col>

                                                <v-col v-for="(item, index) in form.organisation" :key="index" class="my-2 px-2" cols="12">
                                                    <v-col class="px-0 ma-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                        <h5 class="grey--text text--darken-1 text-uppercase">{{ item.organisationName }} CONTRACTOR MANAGER</h5>
                                                        <v-divider class="" />
                                                    </v-col>
                                                    <v-autocomplete  
                                                        :menu-props="{ top: true, offsetY: true }" 
                                                        :attach="true" 
                                                        color="black"  
                                                        no-data-text="Please Select Organisation First" 
                                                        :label="$t(`fields.organisationManager`)" 
                                                        :rules="rules.organisationManager" 
                                                        v-model="item.organisationManager" 
                                                        :items="usersFromOrganisation(item.organisationId)" 
                                                        item-text="userName" 
                                                        return-object 
                                                        required 
                                                        filled 
                                                        auto-select-first
                                                        hide-details="auto" 
                                                        :background-color="formBackground" 
                                                        dense 
                                                        :clearable="!formReadOnly" 
                                                        :readonly="formReadOnly" 
                                                        :class="{ 'disabled': formReadOnly}">
                                                        <template v-slot:item="data">
                                                            {{ data.item.userName }}<br />
                                                            <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                            <span v-if="data.item.userStatus === 'PENDING'" class="caption grey--text font-weight-bold pl-1">(PENDING)</span>
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.userName }}<br />
                                                            <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>, 
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <!-- <pre>form = {{ form }}</pre> -->
                                            </v-row>
                                        </v-form>
                                        <!-- <pre>usersHosts: {{ usersHosts }}</pre> -->
                                        <!-- INFO -->
                                        <v-row class="ma-0 pa-0" no-gutters  v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                                            <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <h5 class="grey--text text--darken-1">INFO</h5>
                                                <v-divider class="" />
                                                <div class="caption grey--text text--darken-1 mt-2">
                                                    <strong>{{$t('fields.created')}}:</strong> {{ form.createdUserData.userName }} - {{ form.createdUserData.organisationName }} - {{ MIX_formatDateTime(form.createdDateTime, 'x', 'DD-MMM-YYYY') }} |
                                                    <strong>{{$t('fields.modified')}}:</strong> {{ form.modifiedUserData.userName }} - {{ form.modifiedUserData.organisationName }} - {{ MIX_formatDateTime(form.modifiedDateTime, 'x', 'DD-MMM-YYYY') }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- COMMENTS -->
                            <v-tab-item value="comments" class="pa-0">
                                   <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="ma-0 pl-3 pr-2">
                                            <v-col cols="12" class="pa-1">
                                                <app-text category="tab-title">COMMENTS</app-text>
                                                <app-text category="tab-text">Below is a list of Comments left about the organisation {{form.concernName}}, You can use this page to Add additional comments which can be marked private for internal use only (not shown to organisations or visitors).</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                            <v-col cols="12" class="d-flex pa-0 pl-1 mt-2">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_comment(true, 'concerns', form.id, form.comments)" />
                                            </v-col>
                                            <v-col cols="12" class="pa-1 mt-4 pr-2">
                                                <v-data-table
                                                    :headers="commentsHeaders"
                                                    :items="commentsTableData"
                                                    :items-per-page="10"
                                                    class="elevation-1">
                                                        <template v-slot:[`item.private`]="{ item }">
                                                            <v-icon v-if="item.private === true">icons8-lock</v-icon>
                                                            <v-icon v-if="item.private === false"></v-icon>
                                                        </template>
                                                         <template v-slot:[`item.createdDateTime`]="{ item }">
                                                            <span>{{MIX_formatDateTime(item.createdDateTime, 'x', 'DD-MMM-YY HH:mm')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <v-icon @click="MIX_editComment(true, item.id, true, item)">icons8-edit-property</v-icon>
                                                            <v-icon @click="MIX_deleteCollectionArray(item.id, item, 'comments')">icons8-trash</v-icon>
                                                        </template>
                                                        <template v-slot:[`item.concernStatus`]="{ item }">
                                                            <v-icon v-if="item.concernStatus === 'RESOLVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'projects',
            collectionTitle: 'Projects',
            collectionItem: 'project',
            collectionItemTitle: 'Project',
            langPath: 'projects.project',
            tabs: 'project',
            // * FORM RELATED
            form: {
                projectName: '',
                projectRef: '',
                siteID: '',
                projectStartDate: '',
                projectEndDate: '',
                projectDescription: '',
                projectManager: {},
                // siteManager: {},
                organisation: '', // TODO CHANGE TO ORGANISATION
                organisationManager: [],
                status: 'PENDING',
                comments: [],
                createdUserId: '',
                createdUserData: {},
                createdDateTime: '',
                modifiedUserId: '',
                modifiedUserData: {},
                modifiedDateTime: '',
                inviteStaff: false,
                invitedStaffMembers: []
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',

            permitToWork: false,
            
            sites: [], // Stores List of Sites

            // * COMMENTS RELATED
            commentsTableData: [], // populated from firestore on show comments
            showComments: false, // determins if the comments should be shown or not

            // * PROJECT RELATED
            formattedProjectStartDate: '', // holds the formated version of the Project Start Date
            formattedProjectEndDate: '', // holds the formated version of the Project End Date
            projectStatus: [], // Status Options

            organisations: [], // Stores organisations

            // * CONTRACTOR MANAGERS / ADMIN
            organisationManagers: [],
			usersSelected: [], // used for counting usersSelected

            // usersFromOrganisation: [],
            invitedStaffMembers: [],
            TFWUsers: [],
            guide: {
                content: ''
            },
            ownerManagers: [],
            usersHosts: [],

            users: [],
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
                GET_openItem: 'GET_openProject', // Get Open Concern Data
                GET_openProject: 'GET_openProject', // Get Open Project Data
                GET_lookupValues: 'GET_lookupValues',
                GET_usersMA: 'GET_usersMA',
                GET_organisations: 'GET_organisations',
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help',
                GET_sites: 'GET_sites', // Get Sites,
                GET_usersHosts: 'GET_usersHosts'
            }),
            commentsHeaders() {
                return [
                    { text: '',  value: 'private', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Comment',  value: 'comment', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Name', value: 'createdUserData.userName', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Created', value: 'createdDateTime', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
                ]
            },
			// Disable Users that are not approved within user selection dropdowns
			computedTFWStaff() {
                var t = this;
                var TFWUsers = t.TFWUsers

			    TFWUsers = TFWUsers.sort((a, b) => a.userName.localeCompare(b.userName))

                // TFWUsers = TFWUsers.filter(function(item) {
                //     return item.userType = 'CONTRACTOR'
                // })

				return TFWUsers.map((item) => {
					return {
						userId: item.userId,
						userName: `${item.userName} (${item.userStatus})`,
						userStatus: item.userStatus,
						userType: item.userType,
						userRole: item.userRole,
						organisationName: item.organisationName,
						organisationId: item.organisationId,
						disabled: item.userStatus !== "APPROVED", //true //this.disabledItems.includes(item)
					};
				});
			},

        },
        // * WATCH
        watch: {
            // Watch for a change in the Open Project Data and then Update the Breadcrumbs
            // GET CONFIRMATION RESULT
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === t.collection) {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null);
                                t.closeRightPanel();
                                //t.refreshItemView();
                                //t.closeRightPanel();
                            } else {
                                t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
            GET_datePickerResult: {
                // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
                handler() {
                    switch (this.GET_datePickerResult.field) {
                        case 'projectStartDate':
                            this.form.projectStartDate = this.GET_datePickerResult.value; // Update the Form Start Date
                            this.formattedProjectStartDate = this.MIX_formatDateTime(this.form.projectStartDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project Start Date
                            break;
                        case 'projectEndDate':
                            this.form.projectEndDate = this.GET_datePickerResult.value; // Update the Form End Date
                            this.formattedProjectEndDate = this.MIX_formatDateTime(this.form.projectEndDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project End Date
                            break;
                        default:
                            //do nothing
                            break
                    }
                }, deep: true
            },
            // GET_usersMA: {
            //     handler() {
            //         this.organisationManagers = this.GET_usersMA
            //     }, deep: true
            // }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openConcern'}),
            // UPDATE BREADCRUMBS (GENERIC)
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },

            handleStaffMembersSelected() {
                var t = this;
                var invitedStaffMembers = t.invitedStaffMembers

                invitedStaffMembers.forEach(staffMember => {
                    if (t.form.invitedStaffMembers) {
                        var form = t.form.invitedStaffMembers.filter(function(item) {
                            return item.userId === staffMember
                        })
                        if (form.length) {
                            // console.log('has item')
                        } else {
                            const test = t.TFWUsers.filter(function(item) {
                                return item.userId === staffMember
                            })
                            const test2 = test[0]
                            t.form.invitedStaffMembers.push(test2)
                        }
                    } else {
                        var staffDetails = t.TFWUsers.filter(function(item) {
                            return item.userId === staffMember
                        })
                        var staffDetails2 = staffDetails[0]
                        t.form.invitedStaffMembers.push(staffDetails2)

                    }
                });

                t.form.invitedStaffMembers.flat()
            },
            saveOrgManagers() {
                var t = this; 

                var orgs = t.form.organisation

                orgs.forEach(org => {
                    var orgId = org.organisationId
                    var orgManagers = org.organisationManager

                    var managerId = orgManagers.userId
                    var managerName = orgManagers.userName
                    var managerEmail = orgManagers.userEmail
                    var orgManager = {
                        organisationId: orgId,
                        userId: managerId,
                        userName: managerName,
                        userEmail: managerEmail
                    }
                    t.form.organisationManager.push(orgManager)
                });

            },
            usersFromOrganisation(item) {
                // console.log("usersFromOrganisation = " + item)


                var t = this;

                var users = t.users.filter(function(user) {
                    return user.userOrganisation.organisationId === item
                })

                // console.log("users = " + JSON.stringify(users, null, 2))

                return users
            },

            // OPEN ITEM (GENERIC)
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New':
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }
                return;
            },
            // EDIT ITEM
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();
                t.closeRightPanel();
            },
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }             
                
                t.handleStaffMembersSelected()
                t.saveOrgManagers()
                
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                    t.closeRightPanel();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    projectName: [
                        v => !!v || 'Project Name is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    ],
                    ref: [v => !!v || 'Required'],
                    description: [v => !!v || "Description Required"],
                    projectStartDate: [v => !!v || "Project Start Date Required"],
                    projectEndDate: [v => !!v || "Project End Date Required"],
                    siteID: [v => !!v || 'Site is required'],
                    siteManager: [v => !!v || 'Site Manager is Required'],
                    status: [v => !!v || 'Status is required'],
                    organisation: [v => !!v || 'Organisation is required'],
                    organisationManager: [v => !!v || 'organisation Manager is required']
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {
                        //it’s valid, do work
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error);
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    {
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`,
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },

            // OPEN PROJECT
            openProject() {
                var path = '/projects/' + this.GET_openItem.data.id + '/documents'; // Change the Router Path to Project ID / Documents
                this.MIX_closeView();
                this.$router.push({ path: path }).catch((error) => {
                   console.log(error.message); // Console Log any Errors
                });
            },
            // CANCEL PROJECT
            cancelProject() {
                this.formMode = 'View';
                this.formReadOnly = true;
                this.showComments = false;
            },
            // EDIT PROJECT
            editProject() {
                this.formMode = 'Edit';
                this.formReadOnly = false;
                this.showComments = false;
            },
            // CLOSE PROJECT
            closeProject() {
                this.MIX_setPanelLayout(12, 0, false); // set Panel Layout Left Panel, Right Panel, Show Right Panel
            },
            // GET USERS FROM ORGANISATION
            getUsersFromTFW: async function() {
                var t = this;
                var usersResult = await t.MIX_usersFromOrganisation('UshqEqj4OeCGI4JHMjUk')
                // console.log("usersResult + " + JSON.stringify(usersResult, null, 2))
                if (usersResult.code === 1) {
                    t.TFWUsers = usersResult.data;
                } else {
                    console.log('ERROR OCCURED - ' + usersResult.message + '\n' + usersResult.error)
                    // do nothing
                }
            },
            // GET USERS FROM ORGANISATION
            getUsersFromOrganisation: async function() {
                var t = this;
                // console.log('t.form.organisation = ' + JSON.stringify(t.form.organisation, null,2 ))
                if (t.form.organisation !== null && t.form.organisation !== '' && t.form.organisation !== undefined) {
                    var usersResult = await t.MIX_usersFromOrganisation(t.form.organisation.organisationId)
                    if (usersResult.code === 1) {
                        // t.usersFromOrganisation = usersResult.data;
                    } else {
                        // console.log('ERROR OCCURED - ' + usersResult.message + '\n' + usersResult.error)
                        // do nothing
                    }
                } else {
                    // t.usersFromOrganisation = []
                }
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            }
        },
        async mounted() {
            var t = this;
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY
            t.users = t.GET_usersMA; // STORE USERS IN LOCAL ARRAY
            // * LOOKUP RELATED MOUNTED
            t.projectStatus = await t.GET_lookupValues('PROJECTSTATUS');
            t.usersHosts = t.GET_usersHosts; // User Admin and Manager who are Staff

            // console.log("usersHosts = " + JSON.stringify(t.usersHosts, null, 2))

            t.usersHosts = t.usersHosts.sort((a,b) => a.userName.localeCompare(b.userName))


            // * ORGANISATIONS
            var organisations = t.GET_organisations;
            t.organisations = organisations.sort((a,b) => a.organisationName.localeCompare(b.organisationName))
            // var organisations = t.GET_organisations;
            // t.organisations = organisations.filter(x => x.organisationType === 'CONTRACTOR'); // FILTER CONTRACTOR FROM ORGANISATIONS


            // // * FORM RELATED MOUNTED

            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') {
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
                t.form.projectRef = 'TFWP' + this.$moment().format('x');
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details
                t.formattedProjectStartDate = t.MIX_formatDateTime(t.form.projectStartDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
				t.formattedProjectEndDate = t.MIX_formatDateTime(t.form.projectEndDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date

                var siteData = t.form.site

                // console.log(siteData.length)

                if (siteData.length == undefined) {
                    t.form.site = []
                    t.form.site.push(siteData)
                }

                var organisationManager = t.form.organisationManager

                if (organisationManager.length == undefined) {
                    t.form.organisationManager = []
                    t.form.organisationManager.push(organisationManager)
                }
                
                var organisation = t.form.organisation

                if (organisation.length == undefined) {
                    t.form.organisation = []
                    t.form.organisation.push(organisation)
                }
                
                
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.getUsersFromOrganisation();
            }
            t.getUsersFromTFW();
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
            // * SET PHOTO UPLOAD DEFAULTS
            if (t.form.id !== '') {
               // console.log('form.id = ' + t.form.id)
                t.MIX_photoUpload({type: 'concerns', typeId: t.form.id, allowedTypes: 'image/*', folder: 'concerntest' })
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title

            var getGuide = await t.MIX_readDocumentById('guides', t.collection)
            if (getGuide.code === -1) {
                // Help Guide Does Not Exist
            } else {
                t.guide = getGuide.data;
            }
        }
    };
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
</style>
